import { useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const useURLParams = () => {
    const location = useLocation();
    const [urlParams, setURLParams] = useState({});
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const params = {};
        for (const [key, value] of searchParams.entries()) {
            params[key] = value;
        }
        setURLParams(params);
    }, [location.search]);
    const memoizedURLParams = useMemo(() => urlParams, [urlParams]);
    return memoizedURLParams;
};

export { useURLParams as default };
//# sourceMappingURL=useURLParams.js.map
